import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromApp from '@app/store/app.reducers';
import { getAllPersonas, getSelectedPersona } from '@app/persona/store';
import { map, tap } from 'rxjs/operators';
import { PersonaUI, toPersonaUI } from '@app/persona/containers/persona-list/persona-map';
import { Observable } from 'rxjs';
import { Persona } from '@app/persona/models';
import { PersonaTypes, PersonaUITypes } from '@app/persona/constants/constants';

@Component({
    selector: 'app-persona-list',
    templateUrl: './persona-list.component.html',
    styleUrls: ['./persona-list.component.scss']
})
export class PersonaListComponent implements OnInit {

    @Output() ngModelChange = new EventEmitter<string>();
    @Input() excludeTypes: PersonaTypes[] = [];
    @Input() isGrid = false;

    icons: { [key: string]: string };
    personaList$: Observable<PersonaUI[]>;

    selectedPersonaId: number;
    prevValue: number = null;
    value: number;

    getPersonaList$() {
        return this.store.pipe(
            select(getAllPersonas),
            map(excludeTypesFnBuilder(this.excludeTypes)),
            map(items => items.map(toPersonaUI)),
            map(sortPersonaUIFn),
            map(this.setupShowMeEverything)
        );
    }

    getSelectedPersona$() {
        return this.store
            .pipe(
                select(getSelectedPersona),
                map(item => !!item ? item : { organisationGroupId: null }),
                map(item => item.organisationGroupId),
                tap(id => this.selectedPersonaId = id),
                tap(id => this.prevValue = id),
                tap(id => this.value = id),
            );
    }

    constructor(private store: Store<fromApp.AppState>) {
    }

    change(value) {
        this.ngModelChange.emit(value);
    }

    reset() {
        this.value = this.selectedPersonaId;
        this.prevValue = null;
    }

    onItemClick(id) {

        if (this.prevValue === id) {
            this.store.select(getAllPersonas)
                .subscribe(personas => {
                    const everyonePersona = personas.find(item => item.name.toLowerCase() === 'everyone');
                    let defaultId = null;
                    if (!!everyonePersona) {
                        defaultId = everyonePersona.organisationGroupId;
                    }
                    this.value = defaultId;
                    this.ngModelChange.emit(`${defaultId}`);
                    this.prevValue = defaultId;
                });
            return;
        }

        this.prevValue = id;

    }

    isTypePersona(type: PersonaUITypes) {
        return type === PersonaUITypes.PERSONA;
    }

    ngOnInit() {
        this.personaList$ = this.getPersonaList$();
        this.getSelectedPersona$().subscribe();
    }

    setupShowMeEverything = items => {
        const everyonePersona = items.find(item => item.title.toLowerCase() === 'everyone');
        items = items.filter(item => item.title.toLowerCase() !== 'everyone');
        const showMeEverythingPersona = { ...everyonePersona, title: 'Everyone', type: '', longText: false };
        return [showMeEverythingPersona, ...items];
    };

}


const sortPersonaUIFn = items => [
    ...items.filter(item => item.type === PersonaUITypes.FILTER),
    ...items.filter(item => item.type === PersonaUITypes.PERSONA)
];
const excludeTypesFnBuilder = (types: PersonaTypes[]) => items => items.filter(item => !types.includes(item.type));


